import { createReducer } from '@reduxjs/toolkit';
import { subscribeTypes } from '@utils/enums.js';

import * as subscribeActions from './subscribeActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  sid: 0,
  uid: 0,
  type: 'email',
  isActive: false,
  isAdded: false,

  sectionTitle: '',
  buttonTitle: '',
  submitText: '',
  thanksMessage: '',
  viewType: 'card',
  collectType: 1,

  isEmail: false,
  isInstagram: false,
  isMessenger: false,
  isPhone: false,
  isTelegram: false,
  isWhatsApp: false,
  isViber: false,

  emailPlaceholder: '',
  emailFileUrl: '',
  emailResultType: 0,
  phonePlaceholder: '',
  phoneFileUrl: '',
  phoneResultType: 0,

  instagramPlaceholder: '',
  instagramUrl: '',
  instagramResultType: 0,
  messengerPlaceholder: '',
  messengerUrl: '',
  messengerResultType: 0,
  telegramPlaceholder: '',
  telegramUrl: '',
  telegramResultType: 0,
  whatsAppPlaceholder: '',
  whatsAppUrl: '',
  whatsAppResultType: 0,
  viberPlaceholder: '',
  viberUrl: '',
  viberResultType: 0,
  submitButtonText: '',
  items: [],

  headingTitle: '',
  headingImage: '',
  headingTextAlign: 'left',
  headingDescription: '',
  headingDivider: '',

  sectionIsBackground: false,
  sectionTextColor: '#000000',
  sectionShadow: 'soft',
  sectionShadowColor: '#000',
  sectionShadowBorderColor: '#ECECF0',
  sectionBorderColor: '#ECECF0',
  sectionShape: 'round',
  sectionOpacity: 0,
  sectionBackgroundColor: '#ffffff',
  sectionIsFullWidth: false,
  sectionPadding: 20,
  sectionMargin: 12,
  sectionBackgroundType: 1,
  sectionBackgroundImage: '',
  sectionGradientColor1: '#B3F7EF',
  sectionGradientColor2: '#F7D6E0',
  sectionGradientDirection: 0,
  sectionGradientOffset: 0,
  sectionBorder: 'none',

  buttonText: 'Subscribe',
  buttonBackgroundColor: '#000000',
  buttonTextColor: '#ffffff',
  buttonShadow: 'none',
  buttonShadowColor: '#000',
  buttonBorder: 'none',
  buttonBorderColor: '#ECECF0',
  buttonShape: 'round',
  buttonOpacity: 0,
};

const subscribe = createReducer(initialState, (builder) => {
  builder
    .addCase(subscribeActions.subscribeUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(subscribeActions.subscribeUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(subscribeActions.subscribeUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(subscribeActions.subscribeStore, (state, { payload }) => {
      const { isAdded, isActive, data, uid, sid } = payload;

      const section = data ?? {};
      let {
        id,
        emailButtonText,
        emailTitle,
        view,
        emailCollectType,
        fileUrl,
        thanksMessage,

        isEmailCollect,
        isInstagramCollect,
        isMessengerCollect,
        isPhoneCollect,
        isTelegramCollect,
        isWhatsAppCollect,
        isViberCollect,

        emailFileUrl,
        emailPlaceholder,
        emailResultType,

        phoneFileUrl,
        phonePlaceholder,
        phoneResultType,

        instagramPlaceholder,
        instagramUrl,
        instagramResultType,
        messengerPlaceholder,
        messengerUrl,
        messengerResultType,
        telegramPlaceholder,
        telegramUrl,
        telegramResultType,
        whatsAppPlaceholder,
        whatsAppUrl,
        whatsAppResultType,
        items,
        submitButtonText,

        headingTitle,
        headingDescription,
        headingImage,
        headingTextAlign,
        headingDivider,

        sectionBackgroundColor,
        sectionTextColor,
        sectionOpacity,
        sectionIsFullWidth,
        sectionShadow,
        sectionShadowColor,
        sectionShadowBorderColor,
        sectionPadding,
        sectionMargin,
        isSectionBackground,
        sectionBackgroundType,
        sectionBackgroundImage,
        sectionGradientColor1,
        sectionGradientColor2,
        sectionGradientDirection,
        sectionGradientOffset,
        sectionShape,
        sectionBorderColor,
        sectionBorder,

        buttonText,
        buttonBackgroundColor,
        buttonTextColor,
        buttonOpacity,
        buttonBorder,
        buttonBorderColor,
        buttonShadow,
        buttonShadowColor,
        buttonShape,
      } = section;

      items?.forEach(({ type }) => {
        switch (type) {
          case subscribeTypes.email:
            isEmailCollect = true;
            break;
          case subscribeTypes.instagram:
            isInstagramCollect = true;
            break;
          case subscribeTypes.messenger:
            isMessengerCollect = true;
            break;
          case subscribeTypes.phone:
            isPhoneCollect = true;
            break;
          case subscribeTypes.telegram:
            isTelegramCollect = true;
            break;
          case subscribeTypes.whatsapp:
            isWhatsAppCollect = true;
            break;
          case subscribeTypes.viber:
            isViberCollect = true;
            break;
          default:
            break;
        }
      });

      return {
        ...state,

        error: null,
        requesting: false,

        id: id ?? 0,
        sid: sid ?? 0,
        uid: uid ?? 0,
        isActive: isActive,
        isAdded: isAdded,

        sectionTitle: emailTitle ?? '',
        buttonTitle: emailButtonText ?? '',
        submitText: fileUrl ?? '',
        viewType: view ?? 'card',
        collectType: emailCollectType ?? 1,
        thanksMessage: thanksMessage ?? '',

        isEmail: isEmailCollect ?? false,
        isInstagram: isInstagramCollect ?? false,
        isMessenger: isMessengerCollect ?? false,
        isPhone: isPhoneCollect ?? false,
        isTelegram: isTelegramCollect ?? false,
        isWhatsApp: isWhatsAppCollect ?? false,
        isViber: isViberCollect ?? false,

        emailPlaceholder: emailPlaceholder ?? '',
        emailFileUrl: emailFileUrl ?? '',
        emailResultType: emailResultType ?? 0,
        phonePlaceholder: phonePlaceholder ?? '',
        phoneFileUrl: phoneFileUrl ?? '',
        phoneResultType: phoneResultType ?? 0,

        instagramPlaceholder: instagramPlaceholder ?? '',
        instagramUrl: instagramUrl ?? '',
        instagramResultType: instagramResultType ?? 0,
        messengerPlaceholder: messengerPlaceholder ?? '',
        messengerUrl: messengerUrl ?? '',
        messengerResultType: messengerResultType ?? 0,
        telegramPlaceholder: telegramPlaceholder ?? '',
        telegramUrl: telegramUrl ?? '',
        telegramResultType: telegramResultType ?? 0,
        whatsAppPlaceholder: whatsAppPlaceholder ?? '',
        whatsAppUrl: whatsAppUrl ?? '',
        whatsAppResultType: whatsAppResultType ?? 0,

        buttonText: buttonText ?? '',
        submitButtonText: submitButtonText ?? '',
        buttonBackgroundColor: buttonBackgroundColor ?? '#000000',
        buttonTextColor: buttonTextColor ?? '#ffffff',
        buttonOpacity: buttonOpacity ?? 0,
        buttonBorder: buttonBorder ?? 'none',
        buttonBorderColor: buttonBorderColor ?? '#000',
        buttonShadow: buttonShadow ?? 'none',
        buttonShadowColor: buttonShadowColor ?? '#000',
        buttonShape: buttonShape ?? 'round',

        headingTextAlign: headingTextAlign ?? 'left',
        headingTitle: headingTitle ?? '',
        headingDescription: headingDescription ?? '',
        headingImage: headingImage ?? '',
        headingDivider: headingDivider ?? '',

        sectionMargin: sectionMargin,
        sectionBackgroundColor: sectionBackgroundColor ?? '#ffffff',
        sectionTextColor: sectionTextColor ?? '#000000',
        sectionOpacity: sectionOpacity ?? 0,
        sectionIsFullWidth: sectionIsFullWidth ?? false,
        sectionShadow: sectionShadow ?? 'none',
        sectionShadowColor: sectionShadowColor ?? '#000',
        sectionPadding: sectionPadding,
        sectionIsBackground: isSectionBackground ?? false,
        sectionBackgroundType: sectionBackgroundType ?? 1,
        sectionBackgroundImage: sectionBackgroundImage ?? '',
        sectionGradientColor1: sectionGradientColor1 ?? '#B3F7EF',
        sectionGradientColor2: sectionGradientColor2 ?? '#F7D6E0',
        sectionGradientDirection: sectionGradientDirection ?? 0,
        sectionGradientOffset: sectionGradientOffset ?? 0,
        sectionShadowBorderColor: sectionShadowBorderColor ?? '#000',
        sectionBorderColor: sectionBorderColor ?? '#000',
        sectionShape: sectionShape ?? 'round',
        sectionBorder: sectionBorder ?? 'none',

        items: items ?? [],
      };
    })

    .addCase(subscribeActions.subscribeClear, () => ({ ...initialState }))

    .addCase(subscribeActions.subscribeUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(subscribeActions.subscribeUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(subscribeActions.subscribeUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(subscribeActions.subscribeUpdateSectionTitle, (state, { payload: sectionTitle }) => ({ ...state, sectionTitle }))
    .addCase(subscribeActions.subscribeUpdateButtonTitle, (state, { payload: buttonTitle }) => ({ ...state, buttonTitle }))
    .addCase(subscribeActions.subscribeUpdateSubmitText, (state, { payload: submitText }) => ({ ...state, submitText }))
    .addCase(subscribeActions.subscribeUpdateViewType, (state, { payload: viewType }) => ({ ...state, viewType }))
    .addCase(subscribeActions.subscribeUpdateCollectType, (state, { payload: collectType }) => ({ ...state, collectType }))
    .addCase(subscribeActions.subscribeUpdateThanksMessage, (state, { payload: thanksMessage }) => ({ ...state, thanksMessage }))

    .addCase(subscribeActions.subscribeUpdateIsEmail, (state, { payload: isEmail }) => ({ ...state, isEmail }))
    .addCase(subscribeActions.subscribeUpdateIsInstagram, (state, { payload: isInstagram }) => ({ ...state, isInstagram }))
    .addCase(subscribeActions.subscribeUpdateIsMessenger, (state, { payload: isMessenger }) => ({ ...state, isMessenger }))
    .addCase(subscribeActions.subscribeUpdateIsPhone, (state, { payload: isPhone }) => ({ ...state, isPhone }))
    .addCase(subscribeActions.subscribeUpdateIsTelegram, (state, { payload: isTelegram }) => ({ ...state, isTelegram }))
    .addCase(subscribeActions.subscribeUpdateIsWhatsApp, (state, { payload: isWhatsApp }) => ({ ...state, isWhatsApp }))
    .addCase(subscribeActions.subscribeUpdateIsViber, (state, { payload: isViber }) => ({ ...state, isViber }))

    .addCase(subscribeActions.subscribeUpdateEmailPlaceholder, (state, { payload: emailPlaceholder }) => ({ ...state, emailPlaceholder }))
    .addCase(subscribeActions.subscribeUpdateEmailFileUrl, (state, { payload: emailFileUrl }) => ({ ...state, emailFileUrl }))
    .addCase(subscribeActions.subscribeUpdateEmailResultType, (state, { payload: emailResultType }) => ({ ...state, emailResultType }))

    .addCase(subscribeActions.subscribeUpdatePhonePlaceholder, (state, { payload: phonePlaceholder }) => ({ ...state, phonePlaceholder }))
    .addCase(subscribeActions.subscribeUpdatePhoneFileUrl, (state, { payload: phoneFileUrl }) => ({ ...state, phoneFileUrl }))
    .addCase(subscribeActions.subscribeUpdatePhoneResultType, (state, { payload: phoneResultType }) => ({ ...state, phoneResultType }))

    .addCase(subscribeActions.subscribeUpdateInstagramPlaceholder, (state, { payload: instagramPlaceholder }) => ({ ...state, instagramPlaceholder }))
    .addCase(subscribeActions.subscribeUpdateInstagramUrl, (state, { payload: instagramUrl }) => ({ ...state, instagramUrl }))
    .addCase(subscribeActions.subscribeUpdateInstagramResultType, (state, { payload: instagramResultType }) => ({ ...state, instagramResultType }))
    .addCase(subscribeActions.subscribeUpdateMessengerPlaceholder, (state, { payload: messengerPlaceholder }) => ({ ...state, messengerPlaceholder }))
    .addCase(subscribeActions.subscribeUpdateMessengerUrl, (state, { payload: messengerUrl }) => ({ ...state, messengerUrl }))
    .addCase(subscribeActions.subscribeUpdateMessengerResultType, (state, { payload: messengerResultType }) => ({ ...state, messengerResultType }))
    .addCase(subscribeActions.subscribeUpdateTelegramPlaceholder, (state, { payload: telegramPlaceholder }) => ({ ...state, telegramPlaceholder }))
    .addCase(subscribeActions.subscribeUpdateTelegramUrl, (state, { payload: telegramUrl }) => ({ ...state, telegramUrl }))
    .addCase(subscribeActions.subscribeUpdateTelegramResultType, (state, { payload: telegramResultType }) => ({ ...state, telegramResultType }))
    .addCase(subscribeActions.subscribeUpdateWhatsAppPlaceholder, (state, { payload: whatsAppPlaceholder }) => ({ ...state, whatsAppPlaceholder }))
    .addCase(subscribeActions.subscribeUpdateWhatsAppUrl, (state, { payload: whatsAppUrl }) => ({ ...state, whatsAppUrl }))
    .addCase(subscribeActions.subscribeUpdateWhatsAppResultType, (state, { payload: whatsAppResultType }) => ({ ...state, whatsAppResultType }))
    .addCase(subscribeActions.subscribeUpdateViberPlaceholder, (state, { payload: viberPlaceholder }) => ({ ...state, viberPlaceholder }))
    .addCase(subscribeActions.subscribeUpdateViberUrl, (state, { payload: viberUrl }) => ({ ...state, viberUrl }))
    .addCase(subscribeActions.subscribeUpdateViberResultType, (state, { payload: viberResultType }) => ({ ...state, viberResultType }))

    .addCase(subscribeActions.subscribeUpdateHeadingTitle, (state, { payload: headingTitle }) => ({ ...state, headingTitle }))
    .addCase(subscribeActions.subscribeUpdateHeadingDescription, (state, { payload: headingDescription }) => ({ ...state, headingDescription }))
    .addCase(subscribeActions.subscribeUpdateHeadingTextAlign, (state, { payload: headingTextAlign }) => ({ ...state, headingTextAlign }))
    .addCase(subscribeActions.subscribeUpdateHeadingImage, (state, { payload: headingImage }) => ({ ...state, headingImage }))
    .addCase(subscribeActions.subscribeUpdateHeadingDivider, (state, { payload: headingDivider }) => ({ ...state, headingDivider }))

    .addCase(subscribeActions.subscribeUpdateSectionIsBackground, (state, { payload: sectionIsBackground }) => ({ ...state, sectionIsBackground }))
    .addCase(subscribeActions.subscribeUpdateSectionTextColor, (state, { payload: sectionTextColor }) => ({ ...state, sectionTextColor }))
    .addCase(subscribeActions.subscribeUpdateSectionBackgroundColor, (state, { payload: sectionBackgroundColor }) => ({ ...state, sectionBackgroundColor }))
    .addCase(subscribeActions.subscribeUpdateSectionOpacity, (state, { payload: sectionOpacity }) => ({ ...state, sectionOpacity }))
    .addCase(subscribeActions.subscribeUpdateSectionIsFullWidth, (state, { payload: sectionIsFullWidth }) => ({ ...state, sectionIsFullWidth }))
    .addCase(subscribeActions.subscribeUpdateSectionShadow, (state, { payload: sectionShadow }) => ({ ...state, sectionShadow }))
    .addCase(subscribeActions.subscribeUpdateSectionShadowColor, (state, { payload: sectionShadowColor }) => ({ ...state, sectionShadowColor }))
    .addCase(subscribeActions.subscribeUpdateSectionPadding, (state, { payload: sectionPadding }) => ({ ...state, sectionPadding }))
    .addCase(subscribeActions.subscribeUpdateSectionMargin, (state, { payload: sectionMargin }) => ({ ...state, sectionMargin }))
    .addCase(subscribeActions.subscribeUpdateSectionBackgroundType, (state, { payload: sectionBackgroundType }) => ({ ...state, sectionBackgroundType }))
    .addCase(subscribeActions.subscribeUpdateSectionBackgroundImage, (state, { payload: sectionBackgroundImage }) => ({ ...state, sectionBackgroundImage }))
    .addCase(subscribeActions.subscribeUpdateSectionGradientColor1, (state, { payload: sectionGradientColor1 }) => ({ ...state, sectionGradientColor1 }))
    .addCase(subscribeActions.subscribeUpdateSectionGradientColor2, (state, { payload: sectionGradientColor2 }) => ({ ...state, sectionGradientColor2 }))
    .addCase(subscribeActions.subscribeUpdateSectionGradientDirection, (state, { payload: sectionGradientDirection }) => ({ ...state, sectionGradientDirection }))
    .addCase(subscribeActions.subscribeUpdateSectionGradientOffset, (state, { payload: sectionGradientOffset }) => ({ ...state, sectionGradientOffset }))
    .addCase(subscribeActions.subscribeUpdateSectionShadowBorderColor, (state, { payload: sectionShadowBorderColor }) => ({ ...state, sectionShadowBorderColor }))
    .addCase(subscribeActions.subscribeUpdateSectionBorderColor, (state, { payload: sectionBorderColor }) => ({ ...state, sectionBorderColor }))
    .addCase(subscribeActions.subscribeUpdateSectionShape, (state, { payload: sectionShape }) => ({ ...state, sectionShape }))
    .addCase(subscribeActions.subscribeUpdateSectionBorder, (state, { payload: sectionBorder }) => ({ ...state, sectionBorder }))

    .addCase(subscribeActions.subscribeUpdateButtonTextColor, (state, { payload: buttonTextColor }) => ({ ...state, buttonTextColor }))
    .addCase(subscribeActions.subscribeUpdateButtonBackgroundColor, (state, { payload: buttonBackgroundColor }) => ({ ...state, buttonBackgroundColor }))
    .addCase(subscribeActions.subscribeUpdateButtonOpacity, (state, { payload: buttonOpacity }) => ({ ...state, buttonOpacity }))
    .addCase(subscribeActions.subscribeUpdateButtonBorder, (state, { payload: buttonBorder }) => ({ ...state, buttonBorder }))
    .addCase(subscribeActions.subscribeUpdateButtonBorderColor, (state, { payload: buttonBorderColor }) => ({ ...state, buttonBorderColor }))
    .addCase(subscribeActions.subscribeUpdateButtonShadow, (state, { payload: buttonShadow }) => ({ ...state, buttonShadow }))
    .addCase(subscribeActions.subscribeUpdateButtonShadowColor, (state, { payload: buttonShadowColor }) => ({ ...state, buttonShadowColor }))
    .addCase(subscribeActions.subscribeUpdateButtonShape, (state, { payload: buttonShape }) => ({ ...state, buttonShape }))

    .addCase(subscribeActions.subscribeUpdateItems, (state, { payload: items }) => ({ ...state, items }));
});

export default subscribe;
